import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import routes from './routes'
import PageOptions from '@/config/PageOptions.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.getters.authenticated) {
      next()
    } else {
      next({ name: 'login', query: { redirectTo: to.fullPath } })
    }
  } else if (to.matched.some(route => route.meta.requiresGuest)) {
    console.log(to.name)
    if(store.getters.authenticated && to.name == 'login'){
      next({ name: 'dashboard' })
    }else {
      next()
    }
  } else {
    next()
  }
})

export default router
